export default __webpack_public_path__ + "static/media/san-rafael-14.41115f7c.jpg";